import { render } from "./trashCanIcon.svg?vue&type=template&id=616b4cc2"
const script = {}
script.render = render

export default script